<!--
//================================================================================
// ID:BC050
// ProjectName: 都営住宅募集オンライン申請
// SystemName: 都営住宅募集オンラインシステム
// JavaScriptName:BC050
//
// <<Modification History>>
// Version	| Date			 | Updated By						| Content
// ---------+------------+-----------------------+--------------------------------
// 01.00.00 | 2021/07/19 | 富士通Japan株式会社		| 新規作成
// 01.03.00 | 2023/02/13 | 富士通Japan株式会社		| 令和4年度改修対応（3次リリース）
// 01.04.00 | 2023/09/27 | 富士通Japan株式会社		| 令和5年度改修対応（3次リリース）
//================================================================================
-->
<template>
	<div class="contents__main">
		<error-message />

		<h2 class="contents__h2">検索条件</h2>
		<section>
			<table class="contents__table--stripe detail">
				<tbody>
					<tr class="contents__input--tr">
						<th class="contents__input--title bosyu-title">住宅の種別</th>
						<td class="padding__bottom-10">
							<div class="margin__left-15">
								<list-box
									class="contents__input--select width-jyutaku"
									:modelValue="form.jyutakuKind"
									:name="'住宅の種別'"
									:groupId="'jyutakuKindInfo'"
									:listItems="disp.jyutakuKindList"
									:reducedDisplayFlg="true"
									@update:modelValue="changeJyutakuList"
									ref="jyutakuKind"
									tabindex="1"
								/>
							</div>
						</td>
					</tr>
					<tr class="contents__input--tr">
						<th class="contents__input--title bosyu-title">公募年月</th>
						<td class="padding__bottom-10">
							<div class="margin__left-15">
								<year-month-input
									:modelValue="form.ymBosyu"
									:name="'公募年月'"
									:groupId="'ymBosyuInfo'"
									:listItems="disp.ymBosyuList"
									:dateType="YEAR_MONTH_KIND.KOBO"
									@update:modelValue="form.ymBosyu = $event"
									ref="ymBosyu"
									tabindex="2"
								/>
								<itemerror-message :groupId="'ymBosyuInfo'" />
							</div>
						</td>
					</tr>
					<tr></tr>
					<tr></tr>
					<tr>
						<th class="contents__input--title nyukyo-title">
							都営住宅に入居する人数
						</th>
						<td class="padding__bottom-10 background__color--white">
							<div class="margin__left-15">
								<number-input
									class="width-nyukyo"
									:modelValue="form.nyukyoNinzu"
									:maxLength="2"
									:name="'入居予定人数'"
									:groupId="'nyukyoNinzuInfo'"
									:numberType="NUMBERINPUT_TYPE.INTEGER"
									@update:modelValue="inputNyukyoNinzu"
									ref="nyukyoNinzu"
									tabindex="3"
								/>人
								<itemerror-message :groupId="'nyukyoNinzuInfo'" />
							</div>
						</td>
					</tr>
					<tr>
						<th class="contents__input--title margin__bottom-m25">区市町</th>
						<td>
							<div class="margin__left-20">
								<label class="contents__caution"
									>※区市町を選択してください。</label
								>
							</div>
							<div class="margin__left-20">
								<label class="contents__caution">※複数選択が可能です。</label>
							</div>
							<div id="kubuLayer" class="width-kubu-title">
								<label class="padding__left-3per font-size-16">区部</label>
							</div>
								<div class="content">
									<label v-if="disp.kubuMsgFlg" class="padding__left-3per font-size-16">対象の住宅はありません。</label>
									<div class="cond__checkbox margin__left-20">
										<check-box
											:classDiv="'width-kubu'"
											:modelValue="form.kubu"
											:cdType="'L0013'"
											:cdHanyo1="'1'"
											:name="'区部'"
											:enabledItems="disp.kubuList"
											:groupId="'kubuInfo'"
											:classItem="'width-kushibu-range'"
											@update:modelValue="form.kubu = $event"
											ref="kubu"
											tabindex="4" />
										<itemerror-message :groupId="'kubuInfo'"/>
									</div>
								</div>
							<div id="shibuLayer" class="width-shibu-title margin__top-5">
								<label class="padding__left-3per font-size-16">市部</label>
							</div>
							<transition name="open">
								<div v-if="disp.isShibuOpen">
									<label v-if="disp.shibuMsgFlg" class="padding__left-3per font-size-16">対象の住宅はありません。</label>
									<div class="cond__checkbox margin__left-20">
										<check-box
											:classDiv="'width-shibu'"
											:modelValue="form.shibu"
											:cdType="'L0013'"
											:cdHanyo1="'2'"
											:name="'市部'"
											:enabledItems="disp.shibuList"
											:groupId="'shibuInfo'"
											:classItem="'width-kushibu-range'"
											@update:modelValue="form.shibu = $event"
											ref="shibu"
											tabindex="5"
										/>
										<itemerror-message :groupId="'shibuInfo'"/>
									</div>
								</div>
							</transition>
						</td>
					</tr>
					<tr>
						<th class="contents__input--title margin__left-20">状況</th>
						<td class="contents__input--label">
							<div>
								<check-box
									:classDiv="'width-shibu'"
									:modelValue="form.zyokyo"
									:name="'状況'"
									:groupId="'nmCdInfo'"
									:cdType="'L0096'"
									@update:modelValue="form.zyokyo = $event"
									ref="zyokyo"
									tabindex="6"
								/>
							</div>
						</td>
					</tr>
					<tr>
						<th class="contents__input--title margin__bottom-m25">
							公開開始日
						</th>
						<td class="contents__input--label">
							<div class="margin__left-15">
								<div class="date">
									<date-input
										:modelValue="form.koukaikaishiFrom"
										:name="'公開開始日（自）'"
										:dateType="DATE_KIND.KOKAI_START"
										:groupId="'koukaikaisiInfo'"
										@update:modelValue="form.koukaikaishiFrom = $event"
										ref="koukaikaishiFrom"
										tabindex="7"
									/>
									<span class="date-to">～</span>
									<date-input
										:modelValue="form.koukaikaishiTo"
										:name="'公開開始日（至）'"
										:dateType="DATE_KIND.KOKAI_START"
										:groupId="'koukaikaisiInfo'"
										@update:modelValue="form.koukaikaishiTo = $event"
										ref="koukaikaishiTo"
										tabindex="10"
									/>
								</div>
								<itemerror-message :groupId="'koukaikaisiInfo'" />
							</div>
						</td>
					</tr>
					<tr>
						<th class="contents__input--title margin__bottom-m25">
							公開終了日
						</th>
						<td class="contents__input--label">
							<div class="margin__left-15">
								<div class="date">
									<date-input
										:modelValue="form.koukaisyuryoFrom"
										:name="'公開終了日（自）'"
										:groupId="'koukaisyuryoInfo'"
										:dateType="DATE_KIND.KOKAI_END"
										@update:modelValue="form.koukaisyuryoFrom = $event"
										ref="koukaisyuryoFrom"
										tabindex="13"
									/>
									<span class="date-to">～</span>
									<date-input
										:modelValue="form.koukaisyuryoTo"
										:name="'公開終了日（至）'"
										:groupId="'koukaisyuryoInfo'"
										:dateType="DATE_KIND.KOKAI_END"
										@update:modelValue="form.koukaisyuryoTo = $event"
										ref="koukaisyuryoTo"
										tabindex="16"
									/>
								</div>
								<itemerror-message :groupId="'koukaisyuryoInfo'" />
							</div>
						</td>
					</tr>
					<tr>
						<th class="contents__input--title margin__bottom-m25">
							変更反映日
						</th>
						<td class="contents__input--label">
							<div class="margin__left-15">
								<div class="date">
									<date-input
										:modelValue="form.tekiyokaishiFrom"
										:name="'変更反映日（自）'"
										:groupId="'tekiyokaishiInfo'"
										:dateType="DATE_KIND.HENKO_HANEI"
										@update:modelValue="form.tekiyokaishiFrom = $event"
										ref="tekiyokaishiFrom"
										tabindex="19"
									/>
									<span class="date-to">～</span>
									<date-input
										:modelValue="form.tekiyokaishiTo"
										:name="'変更反映日（至）'"
										:groupId="'tekiyokaishiInfo'"
										:dateType="DATE_KIND.HENKO_HANEI"
										@update:modelValue="form.tekiyokaishiTo = $event"
										ref="tekiyokaishiTo"
										tabindex="21"
									/>
								</div>
								<itemerror-message :groupId="'tekiyokaishiInfo'" />
							</div>
						</td>
					</tr>
					<tr>
						<th class="contents__input--title nyukyo-title">申込地区番号</th>
						<td class="padding__bottom-10 background__color--white">
							<div class="margin__left-15">
								<number-input
									class="width-tikuNo"
									:modelValue="form.noMouchiku"
									:maxLength="6"
									:name="'申込地区番号'"
									:groupId="'noMouchikuInfo'"
									:numberType="NUMBERINPUT_TYPE.INTEGER"
									@update:modelValue="form.noMouchiku = $event"
									ref="noMouchiku"
									tabindex="23"
								/>
							<itemerror-message :groupId="'noMouchikuInfo'" />
							</div>
							<div class="contents__caution contents__caution--multiple"></div>
						</td>
					</tr>
					<tr class="width-jyutakuname-title background__color--light-gray">
						<th class="contents__input--title margin__bottom-m18">住宅名</th>
						<td>
							<div class="margin__left-15">
								<text-input
									class="width-jyutakuname"
									:modelValue="form.jyutakuName"
									:maxLength="30"
									:name="'住宅名'"
									:groupId="'jyutakuNameInfo'"
									@update:modelValue="form.jyutakuName = $event"
									ref="jyutakuName"
									tabindex="24"
								/>
							</div>
						</td>
					</tr>
				</tbody>
			</table>
			<br />
			<div class="search-button">
				<input
					type="submit"
					value="検索"
					class="contents__btn--normal"
					tabindex="25"
					@click="clickSearchBtn"
					:disabled="disp.searchBtnDisabledFlg"
				/>
			</div>
			<br />

		</section>
	</div>
</template>

<script>
import ErrorMessage from "@/components/ErrorMessage.vue";
import TextInput from "@/components/TextInput.vue";
import NumberInput from "@/components/NumberInput.vue";
import ListBox from "@/components/ListBox.vue";
import CheckBox from "@/components/CheckBox.vue";
import ItemErrorMessage from "@/components/ItemErrorMessage.vue";
import YearMonthInput from "@/components/YearMonthInput.vue";
import DateInput from "@/components/DateInput.vue";

import { co_post } from "@/common/ajaxUtility.js";

import { co_isEmpty, co_checkHalfNumber } from '@/common/checkUtility.js';
import { co_getMessage } from "@/common/messageUtility.js";
import { co_toTop, co_toTrans } from "@/common/screenUtility.js";


import {
	NUMBERINPUT_TYPE,
	CD_HANDLE_TYPE,
	YEAR_MONTH_KIND,
	DATE_KIND,
} from "@/const/const.js";
import { PATH_BC050_INIT, PATH_BC050_GET_KUSHIBU, PATH_BC050_COUNT } from "@/const/route.js";
import {
	STORE_ERROR_CLEAR,
	STORE_ERROR_IS_ERRFLG,
	STORE_ERROR_SETMSG,
	STORE_DATA_ADD_DATA,
	STORE_DATA_GETDATA,
	STORE_ENV_GET_LIST_MAX_COUNT,
	STORE_VIEW_PROGRESS,
	STORE_ERROR_SET_INPUT_ERR,
	STORE_VIEW_CLEAR_PAGE,
} from "@/const/store.js";

export default {
	name: "BC050",
	components: {
		"error-message": ErrorMessage,
		"text-input": TextInput,
		"number-input": NumberInput,
		"list-box": ListBox,
		"check-box": CheckBox,
		"itemerror-message": ItemErrorMessage,
		"year-month-input": YearMonthInput,
		"date-input": DateInput,
	},
	data: function () {
		return {
			form: {
				jyutakuKind: "",					// 住宅の種別
				ymBosyu: "",						// 公募年月
				nyukyoNinzu: "",					// 入居人数
				kushicyoList: [],					// 区市町リスト
				zyokyo: "",							// 状況
				koukaikaishiFrom: "",				// 公開開始日(From)
				koukaikaishiTo: "",					// 公開開始日(To)
				koukaisyuryoFrom: "",				// 公開終了日(From)
				koukaisyuryoTo: "",					// 公開終了日(To)
				tekiyokaishiFrom: "",				// 変更反映(適用開始)日(From)
				tekiyokaishiTo: "",					// 変更反映(適用開始)日(To)
				noMouchiku: "",						// 申込地区番号
				jyutakuName: "",					// 住宅名
				listCount: 0,						// 募集住宅一覧件数
				souPageCnt: 0,						// 総ページ数
			},
			disp: {
				jyutakuDataCount: 0,				// 募集住宅情報対象件数
				kbBosyuList: [],					// 募集の種類マスタデータリスト
				jyutakuDataList: [],				// 住宅の種別マスタデータリスト
				jyutakuKindList: [],				// 住宅の種別リスト
				wsize: 0,							// ウインドウサイズ
				isKubuOpen: true,					// 区部開閉フラグ
				isShibuOpen: true,					// 支部開閉フラグ
				jyutakuKind: "",					// 住宅の種別
				searchBtnDisabledFlg: false,		// 検索ボタン活性・非活性フラグ
				kubuList: [],						// 区部リスト
				shibuList: [],						// 市部リスト
			},

			NUMBERINPUT_TYPE: NUMBERINPUT_TYPE,
			CD_HANDLE_TYPE: CD_HANDLE_TYPE,
			YEAR_MONTH_KIND: YEAR_MONTH_KIND,
			DATE_KIND: DATE_KIND,
		};
	},
	created: async function () {
		// エラークリア
		this.$store.commit(STORE_ERROR_CLEAR);

		// ローディング表示開始
		this.$store.commit(STORE_VIEW_PROGRESS, true);

		// 住宅の種別初期情報取得
		let initData = await co_post(PATH_BC050_INIT);
		this.disp.jyutakuDataList = initData.jyutakuDataList;

		// 前回の検索条件確認
		let data = this.$store.getters[STORE_DATA_GETDATA]("BC050");
		if (data != null) {
			// 検索条件設定
			this.form = data;
			let jyutakuKindList = new Array();
			let list = initData.jyutakuDataList;
			for (let i = 0; i < list.length; i++) {
				jyutakuKindList.push({
					idCd: list[i].kbZyutaku,
					nmCd: list[i].nmZyutaku,
				});
			}
			this.disp.jyutakuKindList = jyutakuKindList;

			// 区市部絞り込み
			this.searchKushibu();

		} else {

			// 住宅の種類初期値設定
			let jyutakuKindList = new Array();
			let list = initData.jyutakuDataList;
			for (let i = 0; i < list.length; i++) {
				jyutakuKindList.push({
					idCd: list[i].kbZyutaku,
					nmCd: list[i].nmZyutaku,
				});
			}
			this.disp.jyutakuKindList = jyutakuKindList;
		}
		if (this.form.ymBosyu == '' && data == null) {
			let currentYear = new Date();
			if(currentYear.getMonth() + 1 >= 1 && currentYear.getMonth() + 1 <=3){
				this.form.ymBosyu = String(currentYear.getFullYear() -1) + "04";
			}else{
				this.form.ymBosyu = String(currentYear.getFullYear()) + "04";
			}
		}
		

		// 日付入力時保持
		await this.$nextTick();
		this.$refs.ymBosyu.setValue(this.form.ymBosyu);
		this.$refs.koukaikaishiFrom.setValue(this.form.koukaikaishiFrom);
		this.$refs.koukaikaishiTo.setValue(this.form.koukaikaishiTo);
		this.$refs.koukaisyuryoFrom.setValue(this.form.koukaisyuryoFrom);
		this.$refs.koukaisyuryoTo.setValue(this.form.koukaisyuryoTo);
		this.$refs.tekiyokaishiFrom.setValue(this.form.tekiyokaishiFrom);
		this.$refs.tekiyokaishiTo.setValue(this.form.tekiyokaishiTo);

		// ローディング表示終了
		this.$store.commit(STORE_VIEW_PROGRESS, false);
	},
	
	mounted: async function () {
		await this.$nextTick();

		// フォーカス制御
		this.$refs.jyutakuKind.focus();

		// ページトップへ遷移
		co_toTop();
	},
	methods: {
		// 住宅の種別リスト作成
		makeJyutakuList: function () {
			let jyutakuList = new Array();
			for (let i = 0; i < this.disp.jyutakuDataList.length; i++) {
				jyutakuList.push({
					idCd: this.disp.jyutakuDataList[i].kbZyutaku,
					nmCd: this.disp.jyutakuDataList[i].nmZyutaku,
				});
			}
			return jyutakuList;
		},

		// 住宅の種別リスト変更
		changeJyutakuList: function (val) {
			this.form.jyutakuKind = val;

			// 区部・市部絞り込み
			this.searchKushibu();
		},

		// 入居予定人数入力
		inputNyukyoNinzu: function (val) {
			this.form.nyukyoNinzu = val;

			// 区部・市部絞り込み
			this.searchKushibu();
		},

		// 区部・市部絞り込み
		searchKushibu: async function () {

			// 住宅の種別、公募年月、入居人数がそれぞれ入力されている場合
			if (!co_isEmpty(this.form.jyutakuKind)
				&& !co_isEmpty(this.form.nyukyoNinzu)
				&& co_checkHalfNumber(this.form.nyukyoNinzu)) {

				let params = {
					'jyutakuKind' : this.form.jyutakuKind,
					'nyukyoNinzu' : this.form.nyukyoNinzu
				};
				let data = await co_post(PATH_BC050_GET_KUSHIBU, params);
				
				let kubuList = this.form.kubu.split(',');
				let selectKubuList = [];

				this.disp.kubuList = new Array();
				let kubu = data.kushibuList.filter(x => x.cdHanyo1 == '1');
				for (let i = 0; i < kubu.length; i++) {
					this.disp.kubuList.push(kubu[i].idCd);
					if (kubuList.indexOf(kubu[i].idCd) >= 0) {
						selectKubuList.push(kubu[i].idCd);
					}
				}

				// 区部の値を初期化する
				this.form.kubu = '';

				// 対象の区部が取得できなかった場合
				if (this.disp.kubuList.length == 0){
					this.disp.kubuList =[''];
					this.disp.kubuMsgFlg = true;
				} else {
					if ( selectKubuList.length > 0 ) {
						this.form.kubu = selectKubuList.join(',');
					} 
					this.disp.kubuMsgFlg = false;
				}

				let shibuList = this.form.shibu.split(',');
				let selectShibuList = [];

				this.disp.shibuList = new Array();
				let shibu = data.kushibuList.filter(x => x.cdHanyo1 == '2');
				for (let i = 0; i < shibu.length; i++) {
					this.disp.shibuList.push(shibu[i].idCd);
					if (shibuList.indexOf(shibu[i].idCd) >= 0) {
						selectShibuList.push(shibu[i].idCd);
					}
				}

				// 市部の値を初期化する
				this.form.shibu = '';

				// 対象の市部が取得できなかった場合
				if (this.disp.shibuList.length == 0){
					this.disp.shibuList = [''];
					this.disp.shibuMsgFlg = true;
				} else {
					if ( selectShibuList.length > 0 ) {
						this.form.shibu = selectShibuList.join(',');
					} 
					this.disp.shibuMsgFlg = false;
				}
			}
		},

		// 検索ボタン押下
		clickSearchBtn: async function () {
			// 検索ボタン非活性
			this.disp.searchBtnDisabledFlg = true;

			// エラークリア
			this.$store.commit(STORE_ERROR_CLEAR);
			// 単項目チェック
			this.$refs.ymBosyu.validate();
			this.$refs.nyukyoNinzu.validate();
			this.$refs.koukaikaishiFrom.validate();
			this.$refs.koukaikaishiTo.validate();
			this.$refs.koukaisyuryoFrom.validate();
			this.$refs.koukaisyuryoTo.validate();
			this.$refs.tekiyokaishiFrom.validate();
			this.$refs.tekiyokaishiTo.validate();
			this.$refs.noMouchiku.validate();
			this.$refs.jyutakuName.validate();

			// 入力チェックエラーが存在する場合
			if (this.$store.getters[STORE_ERROR_IS_ERRFLG]) {
				// 検索ボタン活性
				this.disp.searchBtnDisabledFlg = false;
				return;
			}

			let inputError = false;

			// 入居予定人数チェック
			if (!co_isEmpty(this.form.nyukyoNinzu)) {
				if (this.form.nyukyoNinzu < 2 || this.form.nyukyoNinzu > 20) {
					// エラーメッセージ：E0063を表示
					this.$store.commit(STORE_ERROR_SET_INPUT_ERR, {
						id: "nyukyoNinzuInfo",
						msg: co_getMessage("E0063", "入居予定人数", "2人", "20人"),
					});
					this.$refs.nyukyoNinzu.setError();
					if (!inputError) this.$refs.nyukyoNinzu.focus();
					inputError = true;
				}
			}

			//公開開始日チェック
			if (!co_isEmpty(this.form.koukaikaishiFrom)) {
				if (this.form.koukaikaishiFrom > this.form.koukaikaishiTo) {
					// エラーメッセージ：E0094を表示
					this.$store.commit(STORE_ERROR_SET_INPUT_ERR, {
						id: "koukaikaisiInfo",
						msg: co_getMessage("E0094", "公開開始日"),
					});
					this.$refs.koukaikaishiFrom.setError();
					this.$refs.koukaikaishiTo.setError();
					if (!inputError) this.$refs.koukaikaishiFrom.focus();
					this.$refs.koukaikaishiTo.focus();
					inputError = true;
				}
			}

			//公開終了日チェック
			if (!co_isEmpty(this.form.koukaisyuryoFrom)) {
				if (this.form.koukaisyuryoFrom > this.form.koukaisyuryoTo) {
					// エラーメッセージ：E0094を表示
					this.$store.commit(STORE_ERROR_SET_INPUT_ERR, {
						id: "koukaisyuryoInfo",
						msg: co_getMessage("E0094", "公開終了日"),
					});
					this.$refs.koukaisyuryoFrom.setError();
					this.$refs.koukaisyuryoTo.setError();
					if (!inputError) this.$refs.koukaisyuryoFrom.focus();
					this.$refs.koukaisyuryoTo.focus();
					inputError = true;
				}
			}

			//変更反映日チェック
			if (!co_isEmpty(this.form.tekiyokaishiFrom)) {
				if (this.form.tekiyokaishiFrom > this.form.tekiyokaishiTo) {
					// エラーメッセージ：E0094を表示
					this.$store.commit(STORE_ERROR_SET_INPUT_ERR, {
						id: "tekiyokaishiInfo",
						msg: co_getMessage("E0094", "変更反映日"),
					});
					this.$refs.tekiyokaishiFrom.setError();
					this.$refs.tekiyokaishiTo.setError();
					if (!inputError) this.$refs.tekiyokaishiFrom.focus();
					this.$refs.tekiyokaishiTo.focus();
					inputError = true;
				}
			}

			// 入力チェックエラーが存在しない場合
			if (!this.$store.getters[STORE_ERROR_IS_ERRFLG]) {
				if (!co_isEmpty(this.form.buidYears)) {
					let date = new Date();
					this.form.buildYearsCd = this.form.buidYears.substring(0, 1);
					let year = this.form.buidYears.substring(1);

					if (this.form.buildYearsCd == "0") {
						// 建設年度.汎用コード２が'0'の場合
						this.form.buidYearsTo = date.getFullYear();
					} else {
						// 上記以外の場合
						this.form.buidYearsTo = date.getFullYear() - year;
					}
					this.form.buidYearsFrom = date.getFullYear() - year;
				}

				// 区市町コード設定
				let kushicyoCd = "";
				if (!co_isEmpty(this.form.kubu)) {
					if (!co_isEmpty(this.form.shibu)) {
						kushicyoCd = this.form.kubu + "," + this.form.shibu;
					} else {
						kushicyoCd = this.form.kubu;
					}
				} else if (!co_isEmpty(this.form.shibu)) {
					kushicyoCd = this.form.shibu;
				}
				this.form.kushicyoList = new Array();

				if (!co_isEmpty(kushicyoCd)) {
					this.form.kushicyoList = kushicyoCd.split(",");
				}

				// 検索処理実行
				this.doSearch();
			}

			// 検索ボタン活性
			this.disp.searchBtnDisabledFlg = false;
		},

		// 検索実行
		doSearch: async function () {
			//ローディング表示開始
			this.$store.commit(STORE_VIEW_PROGRESS, true);

			let data = await co_post(PATH_BC050_COUNT, this.form);
			let maxCount = this.$store.getters[STORE_ENV_GET_LIST_MAX_COUNT];

			// 取得件数が0件の場合
			if (data.listCount == null || data.listCount == 0) {
				// エラーメッセージ：E0014を表示
				this.$store.commit(STORE_ERROR_SETMSG, co_getMessage("E0014"));

				// ローディング表示終了
				this.$store.commit(STORE_VIEW_PROGRESS, false);

				// ページトップへ遷移
				co_toTop();

				return;

				// 取得件数が最大件数を超えた場合
			} else if (data.listCount > maxCount) {
				// エラーメッセージ：E0013を表示
				this.$store.commit(
					STORE_ERROR_SETMSG,
					co_getMessage("E0013", maxCount)
				);

				// ローディング表示終了
				this.$store.commit(STORE_VIEW_PROGRESS, false);

				// ページトップへ遷移
				co_toTop();

				return;
			}

			// 入力値保持
			this.$store.commit(STORE_DATA_ADD_DATA, { id: "BC050", data: this.form });
			this.$store.commit(STORE_DATA_ADD_DATA, { id: "BC050DISP",data: this.disp});

			// ローディング表示終了
			this.$store.commit(STORE_VIEW_PROGRESS, false);

			// ページング情報クリア
			this.$store.commit(STORE_VIEW_CLEAR_PAGE);

			// 募集住宅一覧画面に遷移
			co_toTrans('BC051', { paramData : this.form });

		},
	},
};
</script>

<style scoped>
.div-right {
	text-align: right;
	font-size: 16px;
}

.div-tyuimargin {
	margin-top: 10px;
	margin-left: 2%;
	margin-right: 2%;
	margin-bottom: 15px;
	padding-bottom: 0px !important;
}

.toroku-tyui {
	width: auto;
	color: red;
}

.square-position {
	padding-right: 20px;
}

.width-filter-title {
	background-color: #cdcdcd !important;
	padding-top: 3px;
	padding-bottom: 3px;
	margin-left: 20px;
	height: 40px;
}

.contents__filter--title {
	padding: 2px 20px 2px 0 !important;
	border-bottom: 1px dashed #aaa;
	width: 94% !important;
}

/* 端末がPCの場合 */
@media screen and (min-width: 768px) {
	.width-jyutaku {
		width: auto;
		max-width: 100%;
		font-size: 16px;
		border: 1px solid #666666;
		border-radius: 3px;
		color: #262626;
		font-family: sans-serif;
	}

	/* 入居予定人数 */
	.nyukyo-title {
		background-color: #fdfdfd;
	}
	.width-nyukyo {
		font-size: 16px;
		background: #fffffa;
		border: 1px solid #666666;
		border-radius: 3px;
		color: #262626;
		padding: 5px 5px;
		font-family: sans-serif;
		width: 3%;
		text-align: right;
		margin-right: 7px;
	}
	.width-tikuNo {
		font-size: 16px;
		background: #fffffa;
		border: 1px solid #666666;
		border-radius: 3px;
		color: #262626;
		padding: 5px 5px;
		font-family: sans-serif;
		width: 10%;
		text-align: right;
		margin-right: 7px;
	}

	/* 住宅名 */
	.width-jyutakuname-title {
		margin: 10px 20px;
		background-color: #f1f2f5;
	}
	
	.width-jyutakuname {
		font-size: 16px;
		background: #fffffa;
		border: 1px solid #666666;
		border-radius: 3px;
		color: #262626;
		padding: 5px 5px;
		font-family: sans-serif;
		width: 90%;
	}

	/* 区市町 */
	.width-kubu-title {
		background-color: #cdcdcd;
		padding-top: 3px;
		padding-bottom: 3px;
		margin-bottom: 5px;
		margin-left: 15px;
	}
	.width-shibu-title {
		background-color: #cdcdcd;
		padding-top: 3px;
		padding-bottom: 3px;
		margin-left: 15px;
	}
	.width-kubu {
		font-size: 16px;
	}
	.width-shibu {
		font-size: 16px;
	}
	
	/* 公開開始日 公開終了日 変更反映日 */
	.date {
		display: flex
	}
	.date-to{
		margin: 0 10px 0 10px
	}
	/* 検索ボタン */
	.search-button {
		text-align: center;
	}

	/* フォントサイズ */
	.font-size {
		font-size: 16px !important;
	}
}
</style>